var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasErrors)?_c('div',{staticClass:"bg-red text-white p-2 rounded-md shadow mb-2"},_vm._l((_vm.flattenedErrors),function(error,i){return _c('p',{key:i},[_vm._v(_vm._s(error))])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }